import { supabase } from './client';

export const insertChangaBoard = async (orderId: string, session?: any) => {
  if (session) {
  }
  
  // Usar upsert para insertar o reactivar (si estaba liberada)
  const result = await supabase.from('changas_board')
    .upsert({ 
      order_id: orderId, 
      published_at: new Date().toISOString(),
      taken_by: null,
      taken_at: null
    }, { 
      onConflict: 'order_id' 
    });
  
  return result;
};
